import { Component, inject, Inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { User } from "../user.component"; // Adjust the import path to your actual User model location
import {
  NgTemplateOutlet,
  NgClass,
  AsyncPipe,
  CurrencyPipe,
  CommonModule,
} from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatOptionModule, MatRippleModule } from "@angular/material/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSortModule } from "@angular/material/sort";
import { MatChipsModule } from "@angular/material/chips";
import { MatAccordion, MatExpansionModule } from "@angular/material/expansion";
import { MatDividerModule } from "@angular/material/divider";
import { ApiService } from "app/service/api.service";
import { FuseConfirmationDialogComponent } from "@fuse/services/confirmation/dialog/dialog.component";
import { API_ROUTE } from "app/api-routes";
import { MatSnackBar, MatSnackBarModule } from "@angular/material/snack-bar";
import { environment } from "environments/environment";
import { AppName } from "environments/app-nam.enum";

@Component({
  selector: "app-user-detail",
  standalone: true,
  imports: [
    MatProgressBarModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatSortModule,
    NgTemplateOutlet,
    MatPaginatorModule,
    NgClass,
    MatSlideToggleModule,
    MatSelectModule,
    MatOptionModule,
    MatCheckboxModule,
    MatRippleModule,
    MatChipsModule,
    AsyncPipe,
    CurrencyPipe,
    CommonModule,
    MatExpansionModule,
    MatAccordion,
    MatDividerModule,
    MatDialogModule,
    MatSnackBarModule,
  ],
  templateUrl: "./user-detail.component.html",
  styleUrls: ["./user-detail.component.scss"],
})
export class UserDetailComponent {
   isIhcl: boolean = false;
  private _snackBar = inject(MatSnackBar);
  constructor(
    public dialogRef: MatDialogRef<UserDetailComponent>,
    public dialog: MatDialog,
    private _apiSerivce: ApiService,
    @Inject(MAT_DIALOG_DATA) public user: any // The user data passed to the dialog
  ) {this._setApp()}

  // Method to handle the edit action
  editUser() {
    // Implement the edit logic (e.g., opening another form dialog)
    this.dialogRef.close({ action: "edit", data: this.user });
  }

  // Optional: Method to handle the close action without editing
  closeDialog() {
    this.dialogRef.close();
  }

  onCancelClick() {
    this.dialogRef.close(false);
  }

  resendEmail() {
    const dialogRef = this.dialog.open(FuseConfirmationDialogComponent, {
      width: "500px",
      data: {
        title: "Confirmation",
        message: `Are you sure you want to send mail to user ?`,
        icon: "heroicons_outline:exclamation-triangle",
        actions: {
          confirm: {
            show: true,
            label: "Send",
            color: "primary",
          },
          cancel: {
            show: true,
            label: "Cancel",
          },
        },
        dismissible: true,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === "confirmed")
        this._apiSerivce
          .post(API_ROUTE.USER.sendEmail(this.user._id), {})
          .subscribe((res: any) => {
            this.openSnackBar(res.msg);
          });
    });
  }

  openSnackBar(message: string, action: string = "") {
    this._snackBar.open(message, action, {
      horizontalPosition: "end",
      verticalPosition: "top",
      duration: 2000,
      panelClass: "app-snackBar",
    });
  }

    _setApp() {
    switch (environment.APP_NAME) {
      case AppName.IHCL:
        this.isIhcl = true;
        break;
    }
  }
}
